// 课次券类型的购买范围：与代金券类型共用 0/1/2/3 语义，以 purchase_scope 单字段为准。
// 存储值保持 2-仅限持卡、3-仅限未持卡；表单/规则展示顺序为 1 新人 → 3 未持卡 → 2 持卡。
// is_new / is_no_card_except_personal 仅用于兼容旧数据和旧接口。
export const cardTicketPurchaseScopes = {
  all: {
    value: 0,
    name: '不限',
    tagType: 'success',// 最开放
  },
  newStudent: {
    value: 1,
    name: '仅限新人',
    tagType: 'danger',// 最严格
  },
  noCard: {
    value: 3,
    name: '仅限未持卡学员',
    tagType: 'info',
  },
  hasCard: {
    value: 2,
    name: '仅限持卡学员',
    tagType: 'warning',
  },
};

// 表单下拉按“新人 → 未持卡 → 持卡”展示；不选 = 不限
export const cardTicketPurchaseScopeOptions = [
  cardTicketPurchaseScopes.newStudent,
  cardTicketPurchaseScopes.noCard,
  cardTicketPurchaseScopes.hasCard,
];

// 列表/下拉展示用：优先按 purchase_scope 判断，旧接口回退到两个布尔字段
export function findCardTicketPurchaseScope(row) {
  const rawValue = row.purchase_scope;
  const value = rawValue === undefined || rawValue === null || rawValue === '' ? null : Number(rawValue);
  if (value !== null) {
    for (const key in cardTicketPurchaseScopes) {
      if (value === cardTicketPurchaseScopes[key].value) return cardTicketPurchaseScopes[key];
    }
  }

  if (row.is_new) return cardTicketPurchaseScopes.newStudent;
  if (row.is_no_card_except_personal) return cardTicketPurchaseScopes.noCard;
  return cardTicketPurchaseScopes.all;
}
